module.exports = __webpack_public_path__ + "static/img/Pets.bd1bac51.png";